export default [
  {
    path: "/users",
    name: "users",
    component: () => import("@/views/user/list/UserList.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Users" },
        { title: "List", active: true }
      ],
      pageTitle: "Usuários",
      rule: "admin"
    }
  },
  {
    path: "/integration-users",
    name: "integration-users",
    component: () =>
      import("@/views/integration-users/list/IntegrationUsersList.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Users" },
        { title: "List", active: true }
      ],
      pageTitle: "Usuários de Integração",
      rule: "admin"
    }
  },
  {
    path: "/users/add",
    name: "users-add",
    component: () => import("@/views/user/user-add/UserAdd.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Users", url: "/users" },
        { title: "Add", active: true }
      ],
      pageTitle: "User Add",
      rule: "editor"
    }
  },
  {
    path: "/users/edit/:userHash",
    name: "users-edit",
    component: () => import("@/views/user/user-edit/UserEdit.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Users", url: "/users" },
        { title: "Edit", active: true }
      ],
      pageTitle: "User Edit",
      rule: "editor"
    }
  },
  {
    path: "/users/view/:userHash",
    name: "users-view",
    component: () => import("@/views/user/UserView.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Users", url: "/users" },
        { title: "View", active: true }
      ],
      pageTitle: "User View",
      rule: "editor"
    }
  },
  {
    path: "/apps/user/user-view/:userId",
    name: "app-user-view",
    component: () => import("@/views/user/UserView.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "User" },
        { title: "View", active: true }
      ],
      pageTitle: "User View",
      rule: "editor"
    }
  },
  {
    path: "/user/profile",
    name: "user-profile-edit",
    component: () => import("@/views/user/user-profile/UserEdit.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "User" },
        { title: "Edit", active: true }
      ],
      pageTitle: "User Edit",
      rule: "editor"
    }
  }
];

